import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { PageTitle } from "./AdminKit";
import { StatusPill } from "./Inquiries";
import { api } from "../../lib/api";

export const Overview = ({ goTo }) => {
  const { data: s } = useQuery({ queryKey: ["admin-stats"], queryFn: () => api.get("/admin/stats").then((r) => r.data) });
  const { data: inq } = useQuery({ queryKey: ["admin-inquiries", ""], queryFn: () => api.get("/admin/inquiries").then((r) => r.data) });
  const recent = (Array.isArray(inq) ? inq : []).slice(0, 6);
  const cards = [
    ["Total RFQs", s?.inquiries ?? 0, "inquiries"],
    ["New RFQs", s?.new ?? 0, "inquiries"],
    ["Products", s?.products ?? 0, "products"],
    ["Categories", s?.categories ?? 0, "categories"],
  ];
  return (
    <div data-testid="admin-overview">
      <PageTitle title="Overview" desc="A quick look at your website activity." />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map(([l, v, t], i) => (
          <button key={l} onClick={() => goTo(t)} data-testid={`admin-kpi-${i}`} className={`p-6 text-left transition-transform hover:-translate-y-0.5 ${i === 1 ? "bg-[#0a6cff] text-white" : "bg-white"}`}>
            <p className={`text-xs font-semibold uppercase tracking-wider ${i === 1 ? "text-white/80" : "text-slate-500"}`}>{l}</p>
            <p className="font-display mt-3 text-5xl font-extrabold">{v}</p>
          </button>
        ))}
      </div>
      <div className="mt-8 bg-white p-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">Latest inquiries</h2>
          <button onClick={() => goTo("inquiries")} className="flex items-center gap-1 text-sm font-semibold text-[#0a6cff]" data-testid="admin-view-all-inquiries">View all <ArrowRight className="h-4 w-4" /></button>
        </div>
        <div className="mt-4 divide-y divide-slate-100">
          {recent.map((r) => (
            <div key={r.id} className="flex flex-wrap items-center justify-between gap-3 py-3 text-sm">
              <div><p className="font-semibold text-slate-900">{r.name} <span className="font-normal text-slate-500">· {r.company || "-"}</span></p><p className="text-slate-500">{r.product || "General"} · {r.quantity || "-"}</p></div>
              <StatusPill status={r.status} />
            </div>
          ))}
          {recent.length === 0 && <p className="py-6 text-sm text-slate-500">No inquiries yet. They will appear here as soon as someone submits an RFQ.</p>}
        </div>
      </div>
    </div>
  );
};
